import { makeStyles } from '@material-ui/core';

interface Props {
	text?: string;
}

const useStyles = makeStyles(() => ({
	loaderContainer: {
		'& h3': {
			color: '#ccc',
			fontSize: 22,
			fontWeight: 500,
		},
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		minHeight: 100,
		width: '100%',
	},
}));

export function NoResults({ text }: Props) {
	const classes = useStyles();

	return (
		<div className={classes.loaderContainer}>
			<h3> {text || 'No hay registros'} </h3>
		</div>
	);
}
